var _defs, _clipPath, _path, _defs2, _clipPath2, _path2, _defs3, _clipPath3, _path3, _g, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2500 2500"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "icon_svg__a",
    cx: 1250,
    cy: 1250,
    r: 1000
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon_svg__a",
    overflow: "visible"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1678.1 812.5H312.5c-34.4 0-62.5-28.1-62.5-62.5V312.5c0-34.4 28.1-62.5 62.5-62.5h1781.3c34.4 0 62.5 28.1 62.5 62.5v21.9c-3.2 262.5-215.7 478.1-478.2 478.1z",
    clipPath: "url(#icon_svg__b)",
    fill: "#f0bf1a"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "icon_svg__c",
    cx: 1250,
    cy: 1250,
    r: 1000
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_svg__d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon_svg__c",
    overflow: "visible"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2159.4 2250H256.3v-562.5h1428.1c262.5 0 475 212.5 475 475v87.5z",
    clipPath: "url(#icon_svg__d)",
    fill: "#3ebeb0"
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "icon_svg__e",
    cx: 1250,
    cy: 1250,
    r: 1000
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_svg__f"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon_svg__e",
    overflow: "visible"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1565.6 1531.3H150V968.8h1415.6c156.3 0 281.3 125 281.3 281.3s-128.1 281.2-281.3 281.2z",
    clipPath: "url(#icon_svg__f)",
    fill: "#07a5de"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "icon_svg__g",
    cx: 1250,
    cy: 1250,
    r: 1000
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_svg__h"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon_svg__g",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1125 968.8H200v562.5h925c21.9-84.4 34.4-178.1 34.4-281.3s-12.5-196.9-34.4-281.2z",
    clipPath: "url(#icon_svg__h)",
    fill: "#231f20"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M746.9 384.4c-168.8 100-309.4 250-396.9 428.1h737.5c-75-171.9-193.8-315.6-340.6-428.1z",
    fill: "#d7a229"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M778.1 2131.3c143.8-115.6 259.4-268.8 331.3-443.8H350c93.8 187.5 243.8 343.8 428.1 443.8z",
    fill: "#019b8f"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h2500v2500H0V0z",
    fill: "none"
  })));
}

export default SvgIcon;